/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Counts of each gateway drill-down stage in the window. Discovery stages come from meta_discovery events; executions from gateway-attributed tool calls.
 */
export type MetaMcpDiscoveryFunnel = {
  /**
   * describe_server calls
   */
  describeServer: number;
  /**
   * describe_tools calls
   */
  describeTools: number;
  /**
   * Tool executions dispatched through the gateway
   */
  executeTool: number;
  /**
   * list_servers calls
   */
  listServers: number;
};

/** @internal */
export const MetaMcpDiscoveryFunnel$inboundSchema: z.ZodMiniType<
  MetaMcpDiscoveryFunnel,
  unknown
> = z.pipe(
  z.object({
    describe_server: z.int(),
    describe_tools: z.int(),
    execute_tool: z.int(),
    list_servers: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "describe_server": "describeServer",
      "describe_tools": "describeTools",
      "execute_tool": "executeTool",
      "list_servers": "listServers",
    });
  }),
);

export function metaMcpDiscoveryFunnelFromJSON(
  jsonString: string,
): SafeParseResult<MetaMcpDiscoveryFunnel, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => MetaMcpDiscoveryFunnel$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'MetaMcpDiscoveryFunnel' from JSON`,
  );
}
